export default "__VITE_ASSET__C926XEfO__"